import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './services/api.service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { checkUserBalance, checkWhiteLabel, initializeUserData } from './app-initializer';
import { Web3Service } from './services/web3.service';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { TabsPage } from './tabs/tabs.page';
import { WhiteLabelService } from './services/whitelabel.service';
import { SmartWalletService } from './services/smart-wallet.service';
import { UserService } from './services/user.service';
import { StarlyToastComponent } from './components/shared/starly-toast/starly-toast.component';

import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

Sentry.init({
  dsn: 'https://7824fb2217642a395b0ca5c28dfd6361@o4510461520707584.ingest.us.sentry.io/4510461525491712',
  environment: environment.production ? 'production' : 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  // Performance Monitoring
  // Reduzido em produção para economizar quota (performance monitoring gera muitos dados)
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  // Session Replay
  // Reduzido em produção porque gravar todas as sessões é muito custoso
  // Mas você pode aumentar se quiser mais dados
  replaysSessionSampleRate: environment.production ? 0.1 : 0.1, // 10% em ambos (você pode aumentar se quiser)
  // IMPORTANTE: Sempre 100% para capturar TODOS os erros
  replaysOnErrorSampleRate: 1.0, // 100% - captura TODAS as sessões que tiveram erros
  // Enable debug mode in development
  debug: !environment.production,
});

@NgModule({
  declarations: [AppComponent, OnboardingComponent, TabsPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ mode: 'md', innerHTMLTemplatesEnabled: true }),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    StarlyToastComponent,
    HttpClientModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    ApiService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: checkUserBalance,
      deps: [Web3Service],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: checkWhiteLabel,
      deps: [WhiteLabelService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (smartWalletService: SmartWalletService) => {
        return async () => {
          return await smartWalletService.auth();
        };
      },
      deps: [SmartWalletService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUserData,
      deps: [UserService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
